const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

const getSelectedOptionValues = (wrapper) => {
	const values = [];
	wrapper
		.querySelectorAll(
			".js-color-swatches input:checked, .js-weight-options input:checked"
		)
		.forEach((input) => {
			if (input.value) values.push(input.value);
		});
	return values;
};

const findMatchingVariant = (variants, selectedValues) => {
	if (!variants?.length || !selectedValues.length) return null;

	return (
		variants.find((variant) => {
			if (!variant.available) return false;
			return selectedValues.every((val) => variant.options.includes(val));
		}) || null
	);
};

const syncCardVariant = (wrapper, variant) => {
	if (!variant) return;

	const link = variant.url || wrapper.dataset.productUrl;
	if (link) {
		wrapper
			.querySelectorAll(".js-color-swatches-link")
			.forEach((item) => item.setAttribute("href", link));
	}

	const variantIdInput = wrapper.querySelector(
		'.card-product-atc__form-wrap input[name="id"]'
	);
	if (variantIdInput) {
		variantIdInput.value = variant.id;
		if (variant.available) {
			variantIdInput.removeAttribute("disabled");
		} else {
			variantIdInput.setAttribute("disabled", "");
		}
	}

	const atcBtn = wrapper.querySelector(".card-product-atc__submit");
	if (atcBtn) {
		if (variant.available) {
			atcBtn.removeAttribute("disabled");
		} else {
			atcBtn.setAttribute("disabled", "");
		}
	}
};

const updateCardImage = (wrapper, variant, productTitle) => {
	const primaryImage = wrapper.querySelector(".media--first");
	const secondaryImage = wrapper.querySelector(".media--second");
	if (!primaryImage || !variant?.featured_media) return;

	const newPrimaryImage = createImageElement(
		variant.featured_media,
		primaryImage.className,
		primaryImage.sizes,
		productTitle
	);

	if (newPrimaryImage.src === primaryImage.src) return;

	let flag = false;
	if (secondaryImage) {
		const secondaryImagePathname = new URL(secondaryImage.src).pathname;
		const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

		if (secondaryImagePathname === newPrimaryImagePathname) {
			primaryImage.remove();
			secondaryImage.classList.remove("media--second");
			secondaryImage.classList.add("media--first");
			flag = true;
		}
	}

	if (!flag) {
		primaryImage.animate(
			{ opacity: [1, 0] },
			{ duration: 200, easing: "ease-in", fill: "forwards" }
		).finished;
		setTimeout(() => {
			primaryImage.replaceWith(newPrimaryImage);
			newPrimaryImage.animate(
				{ opacity: [0, 1] },
				{ duration: 200, easing: "ease-in" }
			);
			if (secondaryImage) secondaryImage.remove();
		}, 200);
	}
};

const onCardOptionChange = (wrapper, input) => {
	if (!input?.checked) return;

	const handleProduct = wrapper.dataset.product;
	const selectedValues = getSelectedOptionValues(wrapper);
	const variantLink = input.dataset.variantLink;

	if (variantLink) {
		wrapper
			.querySelectorAll(".js-color-swatches-link")
			.forEach((item) => item.setAttribute("href", variantLink));
	}

	if (input.dataset.variantId) {
		syncCardVariant(wrapper, {
			id: input.dataset.variantId,
			available: !input.disabled,
			url: variantLink,
		});
	}

	if (!handleProduct || !window.jQuery) return;

	jQuery.getJSON(
		window.Shopify.routes.root + `products/${handleProduct}.js`,
		function (product) {
			const variant = findMatchingVariant(product.variants, selectedValues);
			if (!variant) return;

			syncCardVariant(wrapper, variant);

			if (wrapper.querySelector(".js-color-swatches input:checked") === input) {
				updateCardImage(wrapper, variant, product.title);
			}
		}
	);
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper
			.querySelectorAll(".js-color-swatches input, .js-weight-options input")
			.forEach((input) => {
				input.addEventListener("change", () => onCardOptionChange(wrapper, input));
			});
	});
};

function colorSwatches() {
	checkSwatches();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
	});
}

(function () {
	colorSwatches();
})();
